import React from 'react'
import { createStyles, Grid, makeStyles, Typography } from '@material-ui/core'
import Link from '../Link/Link'
import Button from '../Button/Button'
import { PrismicAccountData } from '@/interfaces/common/prismicAccount'
import { useTranslation } from 'next-i18next'
import { prismicText } from '../Global/CMSText'
import clsx from 'clsx'
import { useRouter } from 'next/router'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      position: 'relative',
      zIndex: 1,
    },
  })
)
type Tprops = {
  text?: PrismicAccountData
  customClasses?: string | string[]
}
const LoginToSeePriceRow = ({ text, customClasses }: Tprops) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const router = useRouter()
  const registerHref = `/register?redirect=${encodeURIComponent(router.asPath)}`

  return (
    <div
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault()
        e.stopPropagation()
      }}
      className={clsx(classes.root, 'login_to_see_price_row', customClasses)}
    >
      <Grid container direction="column" spacing={2}>
        <Grid item className="login_to_see_price_row__title_grid">
          <Typography
            variant="h5"
            component="p"
            className="login_to_see_price_row__title"
          >
            {prismicText(
              text?.login_to_see_price,
              t('texts:account:login_to_see_price')
            )}
          </Typography>
        </Grid>
        <Grid item className="login_to_see_price_row__link_grid">
          <Link href={registerHref} passHref>
            <a href={registerHref} className="login_to_see_price_row__link">
              <Button component="span" variant="contained" color="secondary">
                {prismicText(
                  text?.login_button,
                  t('texts:account:login_button')
                )}
              </Button>
            </a>
          </Link>
        </Grid>
      </Grid>
    </div>
  )
}

export default LoginToSeePriceRow
